import React, { useState } from 'react';
import { createPortal } from 'react-dom';

export default function IFramePreview({ children, className, style }) {
    const [mountNode, setMountNode] = useState(null);
    
    const handleLoad = (e) => {
        const contentWindow = e.target.contentWindow;
        if (contentWindow && contentWindow.document) {
            const doc = contentWindow.document;
            // FIX: Copy parent styles into the iframe so Tailwind classes and custom fonts render correctly
            Array.from(document.querySelectorAll('style, link[rel="stylesheet"]')).forEach(tag => {
                doc.head.appendChild(tag.cloneNode(true));
            });
            setMountNode(doc.body);
        }
    };

    return (
        <>
            <iframe
                title="Mobile Preview"
                onLoad={handleLoad}
                className={className}
                style={style}
                srcDoc="<!DOCTYPE html><html><head><meta name='viewport' content='width=device-width, initial-scale=1.0'><script src='https://cdn.tailwindcss.com'></script></head><body style='margin:0; padding:0; overflow-x:hidden;'></body></html>"
            />
            {mountNode && createPortal(children, mountNode)}
        </>
    );
}